import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import SiteHeader from "@/components/SiteHeader";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import IdentityMasthead from "@/components/IdentityMasthead";
import SeoHead, { getRouteSeo } from "@/components/SeoHead";
import Home from "@/pages/Home";
import Insights from "@/pages/Insights";
import Articles from "@/pages/Articles";
import ArticlePage from "@/pages/ArticlePage";
import InsightsEditor from "@/pages/InsightsEditor";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import DecisionLedger from "@/pages/DecisionLedger";
import Frameworks from "@/pages/Frameworks";
import Transformations from "@/pages/Transformations";
import Book from "@/pages/Book";
import Speaking from "@/pages/Speaking";
import About from "@/pages/About";
import Connect from "@/pages/Connect";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function RouteSeo() {
  const { pathname } = useLocation();
  const seo = getRouteSeo(pathname);
  return seo ? <SeoHead {...seo} /> : null;
}

function PublicIdentityMasthead() {
  const { pathname } = useLocation();
  const publicEntryPaths = ["/", "/about", "/insights", "/articles", "/frameworks", "/transformations", "/book", "/speaking", "/connect", "/decision-ledger"];
  const fullMastheadPaths = ["/about"];
  const isPublicArticle = pathname.startsWith("/insights/") && pathname !== "/insights/manage";

  if (!publicEntryPaths.includes(pathname) && !isPublicArticle) return null;
  return <IdentityMasthead compact={!fullMastheadPaths.includes(pathname)} />;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RouteSeo />
      <SiteHeader />
      <PublicIdentityMasthead />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />
        <Route path="/decision-ledger/snapshot/:snapshotId" element={<ProtectedRoute adminOnly><DecisionLedger /></ProtectedRoute>} />
        <Route path="/decision-ledger" element={<DecisionLedger />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/insights/manage" element={<ProtectedRoute adminOnly><InsightsEditor /></ProtectedRoute>} />
        <Route path="/insights/:slug" element={<ArticlePage />} />
        <Route path="/frameworks" element={<Frameworks />} />
        <Route path="/transformations" element={<Transformations />} />
        <Route path="/book" element={<Book />} />
        <Route path="/speaking" element={<Speaking />} />
        <Route path="/about" element={<About />} />
        <Route path="/connect" element={<Connect />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
